module.exports = __webpack_public_path__ + "img/icon-status-04.ca8776fd.svg";